var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-col",
    { attrs: { "no-margin": "", xs: "12" } },
    [
      !_vm.tiny || _vm.expanded
        ? _c(
            "w-row",
            { style: { marginTop: _vm.topMargin + "px" } },
            _vm._l(_vm.computedGroupIds, function (id) {
              return _c(
                "w-col",
                { key: id, staticClass: "choose-group", attrs: { xs: 12 } },
                [
                  _c(
                    "w-link",
                    {
                      attrs: { disabled: _vm.disabled },
                      on: {
                        click: function ($event) {
                          return _vm.openBrowseModal(id)
                        },
                      },
                    },
                    [
                      _c("w-fa", { attrs: { icon: "search" } }),
                      _vm._v(
                        " " + _vm._s(_vm.$ct(`contact-search-${id}`)) + " "
                      ),
                    ],
                    1
                  ),
                  (id == 1 || id == 3) &&
                  _vm.showSupplierSwitch &&
                  !_vm.isMobile
                    ? _c(
                        "w-link",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("switch-search-2"),
                              expression: "$ct('switch-search-2')",
                            },
                          ],
                          staticClass: "dark",
                          on: {
                            click: function ($event) {
                              return _vm.onUpdateGroupId(2)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "  | " +
                              _vm._s(
                                _vm.$ct(`components.browse.names.Suppliers`)
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  (id == 1 || id == 2) &&
                  _vm.hasModuleProspecten &&
                  (!_vm.showSupplierSwitch || _vm.showProspectSwitch) &&
                  !_vm.isMobile
                    ? _c(
                        "w-link",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("switch-search-3"),
                              expression: "$ct('switch-search-3')",
                            },
                          ],
                          staticClass: "dark",
                          on: {
                            click: function ($event) {
                              return _vm.onUpdateGroupId(3)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "  | " +
                              _vm._s(
                                _vm.$ct(`components.browse.names.Prospects`)
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  ((id == 3 && _vm.hasModuleProspecten) ||
                    (_vm.showSupplierSwitch && id == 2)) &&
                  !_vm.isMobile
                    ? _c(
                        "w-link",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("switch-search-1"),
                              expression: "$ct('switch-search-1')",
                            },
                          ],
                          staticClass: "dark",
                          on: {
                            click: function ($event) {
                              return _vm.onUpdateGroupId(1)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "  | " +
                              _vm._s(
                                _vm.$ct(`components.browse.names.Clients`)
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.disableCreate
                    ? _c(
                        "w-link",
                        {
                          attrs: { disabled: _vm.disabled || !_vm.canCreate },
                          on: {
                            click: function ($event) {
                              return _vm.openNewContactModal()
                            },
                          },
                        },
                        [
                          _c("w-fa", { attrs: { icon: "plus" } }),
                          _vm._v(" " + _vm._s(_vm.$ct("contact-create")) + " "),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _c(
        "w-row",
        { staticClass: "search-row" },
        [
          _c("app-contact-search", {
            ref: "input",
            staticStyle: { "flex-grow": "1" },
            attrs: {
              disabled: _vm.disabled,
              fancy: _vm.fancy,
              "group-id": _vm.groupId,
              label: _vm.label,
              value: _vm.value,
              "auto-focus": _vm.autoFocus,
              icon: _vm.tiny ? "cog" : "",
            },
            on: {
              "icon-click": function ($event) {
                _vm.expanded = !_vm.expanded
              },
              blur: function ($event) {
                return _vm.onBlur()
              },
              focus: function ($event) {
                return _vm.onFocus()
              },
              input: function ($event) {
                return _vm.onInput($event)
              },
            },
          }),
        ],
        1
      ),
      _vm.createModal
        ? _c(
            "w-modal",
            {
              attrs: { "escape-close": "", "full-height": "" },
              model: {
                value: _vm.createModal,
                callback: function ($$v) {
                  _vm.createModal = $$v
                },
                expression: "createModal",
              },
            },
            [
              _c(
                "w-card",
                {
                  style: { maxWidth: "95%", top: "20px", alignSelf: "center" },
                },
                [
                  _c(
                    "w-card-title",
                    [
                      _vm._v(" " + _vm._s(_vm.$ct("contact-create")) + " "),
                      _c("w-spacer"),
                      _c(
                        "w-link",
                        {
                          attrs: { white: "" },
                          on: {
                            click: function ($event) {
                              _vm.createModal = false
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { style: { height: "calc(100vh - 180px)" } },
                    [
                      _c("app-create-contact", {
                        attrs: { "drawer-button-disabled": "" },
                        on: {
                          cancel: function ($event) {
                            _vm.createModal = false
                          },
                        },
                        model: {
                          value: _vm.newContact,
                          callback: function ($$v) {
                            _vm.newContact = $$v
                          },
                          expression: "newContact",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "", "full-height": "" },
          model: {
            value: _vm.searchModal,
            callback: function ($$v) {
              _vm.searchModal = $$v
            },
            expression: "searchModal",
          },
        },
        [
          _vm.searchModal
            ? _c(
                "w-card",
                {
                  style: {
                    maxWidth: "95%",
                    height: "95%",
                    alignSelf: "center",
                  },
                },
                [
                  _c(
                    "w-card-title",
                    [
                      _vm._v(" " + _vm._s(_vm.$ct("contact-search")) + " "),
                      _c("w-spacer"),
                      _c(
                        "w-link",
                        {
                          attrs: { white: "" },
                          on: {
                            click: function ($event) {
                              _vm.searchModal = false
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.selectedGroupId == 1
                    ? _c("app-customer-browse", {
                        attrs: { "active-only": "" },
                        on: {
                          click: function ($event) {
                            return _vm.onBrowseItemSelected($event)
                          },
                        },
                      })
                    : _vm.selectedGroupId == 2
                    ? _c("app-supplier-browse", {
                        attrs: { "active-only": "" },
                        on: {
                          click: function ($event) {
                            return _vm.onBrowseItemSelected($event)
                          },
                        },
                      })
                    : _vm.selectedGroupId == 3
                    ? _c("app-prospect-browse", {
                        attrs: { "active-only": "" },
                        on: {
                          click: function ($event) {
                            return _vm.onBrowseItemSelected($event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.selectGroupModalOpen,
            callback: function ($$v) {
              _vm.selectGroupModalOpen = $$v
            },
            expression: "selectGroupModalOpen",
          },
        },
        [
          _c(
            "w-card",
            { attrs: { "max-width": "500" } },
            [
              _c(
                "w-card-title",
                [
                  _vm._v(" " + _vm._s(_vm.$ct("select-contact-group")) + " "),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          _vm.selectGroupModalOpen = false
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-list",
                    _vm._l(_vm.createableContactGroups, function (id) {
                      return _c(
                        "w-list-item",
                        {
                          key: id,
                          on: {
                            click: function ($event) {
                              return _vm.openNewContactModal(id)
                            },
                          },
                        },
                        [
                          _c("w-list-item-text", [
                            _vm._v(_vm._s(_vm.$ct(`titles.${id}-new`))),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }